export const LOGO_SIZE = { width: 708, height: 327 } as const;

export const LOGO_INLINE_SIZE = { phone: 160, desktop: 209 } as const;
